<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    label="Nome"
                    v-model="model.nome"
                    :validations="validations.nome"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="form.modulos.length > 0">
            <rkm-col>
                <rkm-tabs>
                    <rkm-tab
                        v-for="modulo in form.modulos"
                        :key="modulo.id"
                        :title="modulo.nome"
                    >
                        <rkm-row>
                            <rkm-col>
                                <rkm-button
                                    @click="checkAll(modulo.id)"
                                    color="primary"
                                    small
                                >
                                    Marcar todos
                                </rkm-button>

                                <rkm-button
                                    @click="uncheckAll(modulo.id)"
                                    outline
                                    small
                                >
                                    Desmarcar todos
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row cols="3">
                            <rkm-col
                                v-for="funcionalidade in modulo.funcionalidades"
                                :key="funcionalidade.id"
                            >
                                <rkm-area
                                    :title="funcionalidade.nome"
                                    no-margin-top
                                >
                                    <rkm-form-checkbox-group v-model="model.permissoes">
                                        <rkm-form-checkbox
                                            v-for="permissao in funcionalidade.permissoes"
                                            :key="permissao.id"
                                            :value="permissao.id"
                                        >
                                            {{ permissao.nome }}
                                        </rkm-form-checkbox>
                                    </rkm-form-checkbox-group>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>
                    </rkm-tab>
                </rkm-tabs>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                nome: {
                    required: true,
                    min: 3,
                    max: 100,
                },
            }
        },
    },
    created() {

        this.repositories = {
            papel: this.getConectaSusRepository('administracao.papel')
        }

        this.load()
    },
    data: () => ({
        form: {
            modulos: []
        },
        model: {
            permissoes: []
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        checkAll(moduloId) {

            this.form.modulos.find(m => m.id === moduloId).funcionalidades
                .map(f => f.permissoes.map(permissao => {

                    if (!this.model.permissoes.includes(permissao.id)) {

                        this.model.permissoes.push(permissao.id)
                    }
                }))
        },
        uncheckAll(moduloId) {

            this.form.modulos.find(m => m.id === moduloId).funcionalidades
                .map(f => f.permissoes.map(permissao => {

                    const index = this.model.permissoes.findIndex(id => id === permissao.id)

                    if (index >= 0) {

                        this.model.permissoes.splice(index, 1)
                    }
                }))
        },
        load() {

            this.setLoading()

            const request = this.id
                ? this.repositories.papel.edit(this.id)
                : this.repositories.papel.create()

            request
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.papel.update(this.id, this.prepareData())
                        : this.repositories.papel.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            return this.camelObjectKeysToSnakeRecursive(this.clone(this.model))
        },
    },
    mixins: [repository, stringCase, object, error],
    props: {
        id: { type: Number }
    },
}
</script>